import React, { FocusEvent, RefObject, forwardRef, useContext, useState } from 'react';
import { Box, Flex, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { ReactComponent as DatePickerCalendar } from 'svg/common/date-picker-calendar.svg';
import { formatBrandCalendarDate } from 'ts/common/components/date-picker/brandCalendarDateFormat';
import { DatePickerContext } from './DatePicker';

const DatePickerInput = forwardRef(function DatePickerInput(props, ref) {
    const { isInvalid, open, value, brandLocale, brandTimezone, onInputBlur } =
        useContext(DatePickerContext);
    const [isFocused, setIsFocused] = useState(false);

    const {
        onClick,
        onFocus,
        onBlur,
        value: propsValue,
        ...restProps
    } = props as {
        onClick?: (event: unknown) => void;
        onFocus?: (event: unknown) => void;
        onBlur?: (event: unknown) => void;
        value?: string;
        [k: string]: unknown;
    };

    /** While focused show react-datepicker's raw text so keystrokes appear; on blur show the brand-formatted date. */
    const brandDisplayValue = value
        ? formatBrandCalendarDate(value, {
              brandLocale,
              fallbackLocale:
                  typeof navigator !== 'undefined' && typeof navigator.language === 'string'
                      ? navigator.language
                      : undefined,
              timeZone: brandTimezone,
              preset: 'numeric'
          })
        : propsValue;

    const displayValue = isFocused ? propsValue ?? '' : brandDisplayValue;

    return (
        <Flex ref={ref as RefObject<HTMLDivElement>} role="group">
            <InputGroup>
                <InputRightElement>
                    <Box onClick={open} cursor="pointer" padding="8px" marginLeft={undefined}>
                        <DatePickerCalendar />
                    </Box>
                </InputRightElement>
                <Input
                    isInvalid={isInvalid}
                    {...restProps}
                    value={displayValue}
                    onClick={(e) => {
                        onClick?.(e);
                        open();
                    }}
                    onFocus={(e) => {
                        setIsFocused(true);
                        onFocus?.(e);
                        open();
                    }}
                    onBlur={(e: FocusEvent<HTMLInputElement>) => {
                        setIsFocused(false);
                        onBlur?.(e);
                        onInputBlur();
                    }}
                />
            </InputGroup>
        </Flex>
    );
});

export default DatePickerInput;
